export default __webpack_public_path__ + "static/media/bitmap4@2x.46cc1848.jpg";